import { useEffect, useRef, useState } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import ModalPop from "../../home/ModalPop";

export const HeaderCategoryList = [
  {
    id: 1,
    title: `청소의\u00A0달인`,
    link: "#about",
  },
  {
    id: 2,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 3,
    title: `고객후기`,
    link: "#review",
  },
  {
    id: 4,
    title: `무료\u00A0견적요청`,
    link: "pop",
  },
  {
    id: 5,
    title: `비밀채팅 상담`,
    link: "https://open.kakao.com/o/smGltdhi",
  },
  {
    id: 6,
    title: `비대면\u00A0작업요청`,
    link: "",
  },
  {
    id: 7,
    title: `BLOG\u00A0작업사례`,
    link: "#blog",
  },
  {
    id: 8,
    title: `상세\u00A0견적문의`,
    link: "#contact",
  },
];

const MHeader = () => {
  const [opened, { toggle }] = useDisclosure(false);

  const [headerStyle, setHeaderStyle] = useState({ backgroundColor: "white" });

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     if (window.pageYOffset > 150)
  //       setHeaderStyle({ backgroundColor: "white" });
  //     else setHeaderStyle({ backgroundColor: "transparent" });
  //   });
  //   return () => {
  //     window.removeEventListener("scroll", () => {
  //       if (window.pageYOffset > 150)
  //         setHeaderStyle({ backgroundColor: "white" });
  //       else setHeaderStyle({ backgroundColor: "transparent" });
  //     });
  //   };
  // }, []);

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <header className="fixed left-0 top-0 w-full h-fit z-10 text-[#392020]">
        <div
          ref={headerRef}
          id="header"
          // style={headerStyle}
          className="relative w-full h-fit px-2 lg:px-[calc((100%-var(--container))/3)] max-h-20 lg:max-h-32 py-2 lg:pb-0 lg:pt-5 overflow-hidden bg-white z-40"
        >
          <div className="relative w-full h-full flex justify-between items-center gap-6 xl:gap-4 pt-2">
            <Burger
              ref={burgerIconRef}
              opened={opened}
              onClick={toggle}
              className="block xl:hidden"
              size="md"
              color="blue"
            />
            <div className=" relative w-full h-full flex justify-center lg:justify-start items-end gap-6 xl:gap-10">
              <div className="relative w-auto h-full">
                <img
                  alt="logo"
                  onClick={() => (window.location.href = "/")}
                  className="!relative w-auto h-full max-h-12 lg:max-h-14 xl:max-h-20 py-1 lg:pb-2 object-contain cursor-pointer"
                  src="/images/logo.png"
                  width={341}
                  height={113}
                />
              </div>
              <div className=" relative w-fit h-fit hidden lg:block">
                <img
                  onClick={openfunc}
                  className="!relative w-full h-full max-h-20 pt-2 object-contain cursor-pointer"
                  alt="button"
                  src={"images/headerIcon.png"}
                  width={661}
                  height={147}
                />
              </div>
            </div>
            <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
              <IconBrandWhatsapp
                onClick={() => {
                  window.location.href = "tel:010-4321-9728";
                }}
                size={30}
                stroke={1}
                className="text-primary"
              />
            </div>
            <div className="hidden xl:block relative w-fit h-fit">
              <img
                onClick={() => {
                  window.location.href = "tel:010-4321-9728";
                }}
                className="!relative w-full h-full max-h-10 lg:max-h-12 xl:max-h-20 lg:pb-3 object-contain cursor-pointer"
                alt="button"
                src={"images/rightNum.png"}
                width={525}
                height={116}
              />
            </div>
          </div>
        </div>
        <div
          // style={headerStyle}
          className="hidden xl:block relative w-full h-fit lg:px-[calc((100%-var(--container))/3)] overflow-hidden z-40 border-t border-b bg-primary"
        >
          <ul className="hidden relative w-full h-fit max-w-screen-lg xl:max-w-screen-3xl mx-auto border-l text-center xl:grid items-center justify-items-center grid-cols-8 cursor-pointer">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i + "pc"}
                onClick={() => {
                  v.link.includes("#")
                    ? menuOnclick(v.link)
                    : v.link.includes("https")
                      ? window.open(v.link)
                      : openfunc();
                }}
                className={
                  v.id === 8
                    ? "text-center relative w-full h-fit border-r bg-primary text-white py-2"
                    : "text-center relative w-full h-fit border-r bg-white py-2"
                }
              >
                <p
                  className={
                    v.id === 1
                      ? "text-primary"
                      : v.title.includes("BLOG")
                        ? "hidden"
                        : "block"
                  }
                >
                  {v.title}
                </p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: v.title.includes("BLOG") ? v.title : "",
                  }}
                ></p>
              </li>
            ))}
          </ul>
        </div>
        <div
          ref={phoneMenuListRef}
          className="block xl:hidden fixed top-16 left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
        >
          <ul className="border-b bg-white text-font">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i}
                onClick={() => {
                  v.link.includes("#")
                    ? phoneMenuOnclick(v.link)
                    : v.id > 3
                      ? window.open(v.link)
                      : openfunc();
                }}
                className="border-b py-4 text-center"
              >
                <p
                  dangerouslySetInnerHTML={{
                    __html: v.title.includes("BLOG") ? v.title : "",
                  }}
                ></p>
                <p
                  className={
                    v.id === 1
                      ? "text-primary"
                      : v.title.includes("BLOG")
                        ? "hidden"
                        : "block"
                  }
                >
                  {v.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
};

export default MHeader;
